import React, { useState } from "react";
import { cn } from "../../../../lib/utils";
import { useAppContext } from "../../../../context/AppContext";
import DoorColourRadiogroup from "./DoorColourRadiogroup";

import { Input } from "../../ui/Input";
import {
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "../../ui/Form";
import ColourTypeTabs from "../tab/ColourTypeTabs";
import FrameColour from "./FrameColour";

const ExternalDoorColour = ({ methods, isOpen: { ExternalDoorColour },oxide,input_name, name, componentName }) => {
    const {
        state: { selectedExternalColourType, selectedExternalFrameColourType, selectedExternalSlabColourType },
    } = useAppContext();

    // Determine current colour type based on section name
    let currentColourType;
    if (name === "External Panel Colour") {
        currentColourType = selectedExternalSlabColourType;
    } else if (name === "External Frame Colour") {
        currentColourType = selectedExternalFrameColourType;
    } else {
        currentColourType = selectedExternalColourType;
    }

    const {
        setValue,
        control,
        getValues,
        watch,
        formState: { errors },
    } = methods;


    const external_colour = watch('external_door_colour_type')
    return (
        <div
            className={cn(
                "section flex flex-col gap-6 transition-all opacity-0 h-0 ",
                {
                    ["h-full opacity-100"]: ExternalDoorColour.isOpen,
                }
            )}
        >
            <ColourTypeTabs setValue={setValue} oxide={oxide} view="external" name={name} componentName={componentName} input_name={input_name} />
            {currentColourType === 'oxide' &&
            <p className='text-primary mb-0 underline'>
                Oxide Range
            </p>
            }
            <div className="flex flex-wrap [&>div]:max-w-1/4 gap-4">
                <DoorColourRadiogroup
                    {...methods}
                    type={currentColourType}
                    view="external"
                    oxide={oxide}
                    input_name={input_name}
                />
            </div>
            <div className="flex flex-col gap-2">
                <FormField
                    control={control}
                    name="external_custom_ral_color"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel className="text-gray-700">
                                Custom Ral Colour
                            </FormLabel>
                            <FormControl>
                                <Input
                                    type="text"
                                    icon
                                    className="text-gray-700"
                                    placeholder="Enter Ral Colour"
                                    {...field}
                                />
                            </FormControl>

                            {errors.external_custom_ral_color && (
                                <FormMessage>
                                    {errors.external_custom_ral_color.message}
                                </FormMessage>
                            )}
                        </FormItem>
                    )}
                />
            </div>
            {(external_colour === 'oxide' && input_name !== 'panel')&&
                <div className="flex flex-col gap-2">
                    <p className='text-primary mb-0 underline'>
                        Frame Colours
                    </p>
                    <FrameColour {...methods}/>
                </div>
                }

        </div>
    );
};

export default ExternalDoorColour;
